module.exports = __webpack_public_path__ + "templates/eshop-product.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/eshop/templates/eshop-product.html
// module id = F02N
// module chunks = 1